import React from 'react';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { map } from 'lodash';
import classnames from 'classnames';
import { Icon } from 'modules/icon-bank';

import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';
import { WIDGET_NAMES } from 'constants/entity-names';
import { getLabel } from 'utils/getLabel';
import { MemberClaimDetailSummary } from 'ui/containers/MemberClaimDetailSummary';

// widget views
const WIDGET_VIEWS = {
	[ WIDGET_NAMES.CLAIM_DETAILS_SUMMARY ]: MemberClaimDetailSummary,
 };

//  success view
export const memberClaimDetailSuccess = ( props ) => {
	return (
		<div className="ui-member-claim-detail">
			<div className="ui-member-claim-detail__action">
				{ map( props.navActions, ( navAction ) => {

					// get the action for navAction
					const iconId = 'back' === navAction.name ? 'backArrow' : null;

					return (
						<div
							className="ui-member-claim-detail__action__nav-action"
							key={ navAction.name }
							onClick={ () =>
								props.onNavActionClick( {
									type: 'headerAction',
									value: navAction,
								} )
							}
						>
							<Icon id={ iconId } />
							<div className="ui-member-claim-detail__action__nav-action__label">
								{ getLabel( navAction.title ) }
							</div>
						</div>
					);
				} ) }
			</div>

			{ /* widget sequence view */ }
			<div className="ui-member-claim-detail__widgets">
				{ map( props.widgets, ( widget ) => {

					// get widget view
					const WidgetView = WIDGET_VIEWS[ widget.name ];

					// widget class name
					const widgetClassName = classnames(
						'ui-member-claim-detail__widgets__widget'
					);

					return (
						<div key={ widget.name } className={ widgetClassName }>
							<WidgetView
								widget={ widget }
								memberId={ props.memberId }
								onDependentSwitch={ props.onDependentSwitch }
								requestPayload={ props.requestPayload }
							/>
						</div>
					);
				} ) }
			</div>
		</div>
	);
 };

// set display name
memberClaimDetailSuccess.displayName = 'memberClaimDetailSuccess';

// set default props
memberClaimDetailSuccess.defaultProps = {};

// prop types
memberClaimDetailSuccess.propTypes = {};

// preloader view
export const memberClaimDetailPreloader = () => {
	return (
		<div className="ui-member-details-widget-preloader">
			<WidgetPreloader />
		</div>
	);
 };

// set display name
memberClaimDetailPreloader.displayName = 'memberClaimDetailPreloader';

// set default props
memberClaimDetailPreloader.defaultProps = {};

// prop types
memberClaimDetailPreloader.propTypes = {};

/**
 * @type { object }
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberClaimDetail as MemberClaimDetail } from 'ui/views/widgets/memberClaimDetail';
 *
 * // render
 * <MemberClaimDetail propName='propValue'/>
 */

export const memberClaimDetail = withNetworkState(
	memberClaimDetailPreloader,
	memberClaimDetailSuccess
 );
